<template>
<tbody>
    <rate-plan-sell :rate_plan="rate_plan" :prices="prices" @display="show=!show" :context="context" :admin="admin" :params="params" :backup_sheet="backup_sheet"></rate-plan-sell>
    <template v-if="show">
        <stop-sell :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <close-open-sell :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <min-max-sell :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <min-max-advance :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <min-max-inventory :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <min-max-through :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <min-booking-date :prices="prices" :backup_sheet="backup_sheet" :params="params" />
        <max-booking-date :prices="prices" :backup_sheet="backup_sheet" :params="params" />
    </template>
</tbody>
</template>

<script>
import storage from '../../../../storage';
import RatePlanSell from './RatePlanSell.vue';
import StopSell from './StopSell.vue';
import MinMaxSell from './MinMaxSell.vue';
import MinMaxAdvance from './MinMaxAdvance.vue';
import MinMaxInventory from './MinMaxInventory.vue';
import MinMaxThrough from './MinMaxThrough.vue';
import MinBookingDate from './MinBookingDate.vue';
import MaxBookingDate from './MaxBookingDate.vue';
import CloseOpenSell from './CloseOpenSell.vue';
export default {
    props: {
        rate_plan: Object,
        params: Object,
        backup_sheet: [Object, Array],
        prices: Object,
        admin: Boolean,
        context: String,

    },
    components: {
        "rate-plan-sell": RatePlanSell,
        "stop-sell": StopSell,
        "min-max-sell": MinMaxSell,
        "min-max-advance": MinMaxAdvance,
        "min-max-inventory": MinMaxInventory,
        "min-max-through": MinMaxThrough,
        "min-booking-date": MinBookingDate,
        "max-booking-date": MaxBookingDate,
        "close-open-sell": CloseOpenSell,
    },
    data() {
        return {
            show: false,
        }
    },

    mounted() {},

    watch: {},

    methods: {}
}
</script>
